import type { Asset, MediaType } from '../store/seedanceTypes';
import { LIBRARY_PORTRAIT_PAGE_SIZE_MAX } from './libraryPortraitPaging';

export type LibraryMediaFilter = 'all' | MediaType;

/** 单次首屏/筛选补拉最多追加的页数，防止异常分页死循环 */
export const LIBRARY_SPARSE_BACKFILL_MAX_PAGES = 16;

export function countFilteredAssets(assets: Asset[], filter: LibraryMediaFilter): number {
  if (filter === 'all') return assets.length;
  return assets.filter((a) => a.type === filter).length;
}

/** 稀疏补拉时按轮次指数放大 page_size，减少往返次数 */
export function computeAdaptiveBackfillPageSize(basePageSize: number, backfillAttempt: number): number {
  const multiplier = Math.pow(2, Math.max(0, backfillAttempt));
  return Math.min(
    LIBRARY_PORTRAIT_PAGE_SIZE_MAX,
    Math.max(basePageSize, basePageSize * multiplier),
  );
}

export function shouldContinueSparseBackfill(options: {
  filter: LibraryMediaFilter;
  loadedCount: number;
  lastPageCount: number;
  lastPageSize: number;
  hasMore: boolean;
  minFillCount: number;
}): boolean {
  const { filter, loadedCount, lastPageCount, lastPageSize, hasMore, minFillCount } = options;
  if (!hasMore) return false;

  if (filter !== 'all') {
    // 类型筛选：一次会话内尽量拉完，避免哨兵反复触发「加载更多」
    return true;
  }

  if (loadedCount >= minFillCount) return false;
  return lastPageCount >= lastPageSize;
}
